import { type PartnerLinks } from "../../types/partnerLink"
import { Partner } from "../partner"
import { DARTY_PORTAIL_LINKS } from "./darty/dartyPortailLinks"
import { EFFY_PORTAIL_LINKS } from "./effy/effyPortailLinks"

export const links: Record<Partner, PartnerLinks> = {
    [Partner.Darty]: DARTY_PORTAIL_LINKS,
    [Partner.DartyOctopus]: DARTY_PORTAIL_LINKS,
    [Partner.Effy]: EFFY_PORTAIL_LINKS,
}
